import { useEffect, useState } from "react";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
import LazyLoad from "react-lazyload";
import { getPrincipalMessage } from "../Service/Api";
const PrincipalMessage = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const messages = await getPrincipalMessage();
      setData(messages);
    };
    fetchData();
  }, []);
  const emptyArray = [
    // { description: "“Educating the mind without educating the heart is no education at all.” Sacred Heart has been educating boys and girls since 1990; though much has changed over the years our mission remains the same. Sacred Heart is committed to developing students of high academic achievement, intellectual curiosity, and strong moral character. As a result, year after year Sacred Heart sends our respectful, responsible and compassionate young adults, who are well prepared to tackle the challenges that lay ahead. Since arriving at Sacred Heart in 2016, I have had the opportunity to observe this unique institution up close. I have seen its commitment to academic excellence, its dynamic student body, and incredibly committed faculty and a loving community where the students and families are proud and supportive of one another. As I walk down the hallways of the school every day, I can hear the chatter of eager minds; the shouts of excitement from the victorious athletes, the thumb of dancers feed and the sound of melodious voices harmonizing the perpetual energy, movement and enthusiasm permeate the atmosphere. Ours is a school with difference. We value creativity and innovation and strive to nurture them in our students. Sacred Heartians are groomed to become confident, articulate and enlightened young citizens ready to step into the global society with dignity, honour and integrity. Aristotle once said “Educating the mind without educating the heart is no education at all”. Even as we impart education to match the advancement in technology and globalization, we march our children ahead with Sacred Heart ethos of moral values and principles. We Endeavour constantly to instill these qualities in our children. We pride ourselves to help them grow and develop into sensitive, responsible God loving citizens of the future. May the Sacred Heart of Jesus bless us abundantly in all our endeavourers.", attachments: "Principal.jpg" },
  ];
  const homeMenu = [
    { label: "Vision", link: "/about" },
    {
      label: "Management",
      link: "",
      subMenu: [
        { label: "Director's Message", link: "/DirectorMessage" },
        { label: "Principal's Message", link: "/PrincipalMessage" },
        { label: "Leadership Team", link: "/leadershipTeam" },
        { label: "Patron’s Message", link: "/patrons" },
        { label: "Advisory Board", link: "/advisoryBoard" },
      ],
    },

    { label: "International Collaborations", link: "/partnership" },
    // { label: "Awards & Achievements", link: "/awardsAcheivements" },

{
      label: "Awards & Achievements",
      link: "/awardsAcheivements",
      subMenu: [
        { label: "Accolades & Achievements", link: "/awardsAcheivements" },
        { label: "Students Achievements", link: "/studentsAcheivements" },
      ],
    },

    { label: "Faculty", link: "/faculty" },
    { label: "Staff Details", link: "/staffDetails" },
    { label: "School Strength ", link: "/schoolStrength" },
    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-about3.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Management"
                breadEnd="Principal's  Message"
                breadMid="Principal's Message"
              />
            </div>
          </div>
          {data?.length > 0
            ? data
                ?.filter((div) => div.category === "Principal")
                .map((item, index) => (
                  <div className="row justify-content-center msgsec">
                    <div className="col-md-12">
                      <h4 className="color-red">
                        Principal's Message
                      </h4>
                      <div className="wt-team-1 mt-4">
                        {" "}
                        <div className="wt-media">
                          <LazyLoad>
                            {" "}
                            <img
                              src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments}`}
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>{" "}
                        </div>
                      </div>
                      <p>
                        {" "}
                        <b> {item.name} </b>
                      </p>{" "}
                      <div
                        dangerouslySetInnerHTML={{ __html: item.message }}
                      ></div>
                    </div>
                  </div>
                ))
            : emptyArray.map((data, index) => (
                <div key={index} className="row"></div>
              ))}

          {/* <div class="row justify-content-center">
               <div class="col-md-12">

                   <div class="wt-team-1"> <div class="wt-media"><LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LCSD/public/Images/Principal.jpg" alt="Loreto Convent School, Delhi Cantt" class="img-fluid" /> </LazyLoad>
                   <div class="team-social-center"> <ul class="team-social-bar"> <li><a href="javascript:void(0);"><i class="bi bi-facebook"></i></a></li> 
                   <li><a href="javascript:void(0);"><i class="bi bi-twitter"></i></a></li> <li><a href="javascript:void(0);"><i class="bi bi-instagram"></i></a></li> 
                   <li><a href="javascript:void(0);"><i class="bi bi-linkedin"></i></a></li> </ul> </div> </div> </div> <div class="wt-team-1-single"> <div align="justify"> 
                   <p>Dear Students, Parents, and Staff,</p><div><br /></div>
<p>Welcome to another new academic year 2024-2025 which promises to be an exciting journey of learning and growth.</p>
<p>Heartiest congratulations to  our dear students for their wonderful performance at the class 10 and 12 board examinations 2023-2024. With God’s  blessings, hard work and sincerity may you continue to  enjoy the fruits of success.</p>
<p>Thank  you dear parents and stake holders for your constant support which means a lot to us.</p>
<p>A big thank you to the entire staff of Loreto, for your dedication and steadfast commitment to  creating  an inclusive and dynamic learning environment where every student can thrive. </p>
<p>We acknowledge the efforts  and thank our Loreto Sisters, who through the years have guided and  played a pivotal role in the education of the girl child.</p>
<p>We look forward to working towards a  rewarding and fulfilling year ahead with a focus on education,   character development and becoming  responsible global citizens.</p>
<p>At Loreto we believe in empowering every child to develop her potentials and excel in whatever she does. </p>
<p>Let us embrace the opportunities and challenges that come our way with positivity and resilience. </p>
<p>Here’s to a wonderful and productive year ahead!</p>

                   
                   <div>God bless you!</div> <div>Warm regards</div><div><br /></div>  </div> </div>  <p className="bg-color-span">  Mrs. Alice Rose D’Lima <br /> (Principal) </p>

                  
               </div>
            </div> */}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrincipalMessage;
